<p-menu
  #menu
  appendTo="body"
  styleClass="w-20rem"
  [model]="actions"
  [popup]="true"
/>
<p-button
  size="small"
  outlined
  icon="pi pi-ellipsis-v"
  iconPos="left"
  label="Επιλογές"
  class="p-button-collapsible"
  (onClick)="menu.toggle($event)"
/>
